import axiosClient from "./axios";

/**
 * Kullanıcının en son doğum haritası bilgisini getirir
 * @returns {Promise} Doğum haritası verisi
 */
export const getLatestBirthChart = async () => {
  try {
    const response = await axiosClient.get("/module/birthchart/latest");
    return response.data;
  } catch (error) {
    console.error("Doğum haritası alınırken hata:", error);
    throw error;
  }
};

